import { Mode, ReservationBrowsingPeriod } from "models/Mode";
import { TimeRange } from "models/Reservation";

import { getDateFormatted } from "../date/getDateFormatted";

export function getMapStartDate(mode: Mode, browsingPeriod: ReservationBrowsingPeriod, queryData: TimeRange): string {
    switch (mode) {
        case Mode.RESERVATION_BROWSING:
        case Mode.RESERVATION_PREVIEW:
        case Mode.RESERVATION_CREATION:
        case Mode.RESERVATION_EDIT:
            switch (browsingPeriod) {
                case ReservationBrowsingPeriod.EVENING:
                    return getDateFormatted({ date: queryData.start, hour: 17 });

                case ReservationBrowsingPeriod.MORNING:
                    return getDateFormatted({ date: queryData.start, hour: 0 });

                default:
                    return queryData.start;
            }

        case Mode.PRINTING:
            return getDateFormatted({ date: queryData.start, hour: 0 });

        default:
            return queryData.start;
    }
}
